import {CookieConsent} from '@/shared/services/cookieConsent';

import {COOKIE_CONSENT} from './serve/consts';
import {set} from './serve/localStorage';

export function getCookieConsent(): CookieConsent | null {
  if (typeof window === 'undefined') {
    return null;
  }

  // return get<CookieConsent | null>(COOKIE_CONSENT);
  //TODO uncomment when all will be ready
  return {
    timestamp: Date.now(),
    categories: {essential: true, statistics: true, marketing: true},
  };
}

export function setCookieConsent(value: CookieConsent): void {
  if (typeof window === 'undefined') {
    return;
  }

  set<CookieConsent>(COOKIE_CONSENT, value);
}
